"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _isEmpty2 = _interopRequireDefault(require("lodash/isEmpty"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _HotelStars = _interopRequireDefault(require("../HotelStars/HotelStars"));
var _HotelCardFacts = _interopRequireDefault(require("../HotelCardFacts/HotelCardFacts"));
var _HotelCardPrice = _interopRequireDefault(require("../HotelCardPrice/HotelCardPrice"));
var _HotelCardGallery = _interopRequireWildcard(require("../HotelCard/components/HotelCardGallery"));
var _HotelCardOfferInfo = require("../HotelCard/components/HotelCardOfferInfo");
var _HotelCardRating = _interopRequireDefault(require("../HotelCard/components/HotelCardRating"));
var _HotelCardHeaderLabel = _interopRequireDefault(require("../HotelCard/components/Labels/HotelCardHeaderLabel"));
var _HotelCardTitle = _interopRequireDefault(require("../HotelCard/components/HotelCardTitle"));
var _HotelCardSuggestedDates = _interopRequireDefault(require("../HotelCardSuggestedDates/HotelCardSuggestedDates"));
var _HotelCardTags = _interopRequireDefault(require("../HotelCard/components/HotelCardTags"));
var _LabelList = require("../Label/LabelList");
var _cancellationPolicy = require("../HotelCard/components/utils/cancellationPolicy");
var _utils = require("../HotelCardFacts/utils");
var _FiltersPenalized = require("../HotelCard/components/FiltersPenalized");
var _WarningPlacesEnd = _interopRequireDefault(require("../WarningPlacesEnd"));
var _styles = require("../HotelCard/styles");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
// Utils:

var HotelCardSmall = function HotelCardSmall(_ref) {
  var _ref$hotel = _ref.hotel,
    hotel = _ref$hotel === void 0 ? {} : _ref$hotel,
    _ref$extras = _ref.extras,
    extras = _ref$extras === void 0 ? {} : _ref$extras,
    _ref$images = _ref.images,
    images = _ref$images === void 0 ? {
      count: 0,
      list: [],
      onSlideChange: function onSlideChange() {
        return undefined;
      }
    } : _ref$images,
    hotelHref = _ref.hotelHref,
    location = _ref.location,
    price = _ref.price,
    priceWithCashback = _ref.priceWithCashback,
    currencyCode = _ref.currencyCode,
    surcharge = _ref.surcharge,
    nights = _ref.nights,
    date = _ref.date,
    hasLtExtras = _ref.hasLtExtras,
    isViewed = _ref.isViewed,
    isMobile = _ref.isMobile,
    className = _ref.className,
    labels = _ref.labels,
    cancellationPolicy = _ref.cancellationPolicy,
    FooterComponent = _ref.FooterComponent,
    availability = _ref.availability,
    suggestedDates = _ref.suggestedDates,
    bonus_count = _ref.bonus_count,
    cashbackIdentifier = _ref.cashbackIdentifier,
    customCashbackIconURL = _ref.customCashbackIconURL,
    customCashbackText = _ref.customCashbackText,
    customCashbackTooltipText = _ref.customCashbackTooltipText,
    _ref$penalized_filter = _ref.penalized_filters,
    penalized_filters = _ref$penalized_filter === void 0 ? [] : _ref$penalized_filter,
    onChangeFilter = _ref.onChangeFilter,
    dataLayer = _ref.dataLayer,
    isHotelOnly = _ref.isHotelOnly,
    isFlexDates = _ref.isFlexDates,
    _ref$openInCurrentTab = _ref.openInCurrentTab,
    openInCurrentTab = _ref$openInCurrentTab === void 0 ? false : _ref$openInCurrentTab,
    _ref$isPreloadable = _ref.isPreloadable,
    isPreloadable = _ref$isPreloadable === void 0 ? false : _ref$isPreloadable,
    _ref$isMapCard = _ref.isMapCard,
    isMapCard = _ref$isMapCard === void 0 ? false : _ref$isMapCard;
  var rating = hotel.rating,
    stars = hotel.stars,
    _hotel$name = hotel.name,
    name = _hotel$name === void 0 ? '' : _hotel$name,
    _hotel$features = hotel.features,
    features = _hotel$features === void 0 ? {} : _hotel$features;
  var line = features.line,
    beachSurface = features.beach_surface,
    beachDistance = features.beach_distance,
    airportDistance = features.airport_distance,
    wifiType = features.wi_fi;
  var emptyFeature = (0, _utils.isEmptyFeatures)(features);
  var cheap = extras.cheap,
    cheapType = extras.cheap_type,
    previousPrice = extras.previous_price,
    instantConfirm = extras.instant_confirm;
  var maxLabels = 6;
  if (instantConfirm) maxLabels -= 1;
  if ((0, _cancellationPolicy.isFreeCancellation)(cancellationPolicy)) maxLabels -= 1;
  var hasLabel = !(0, _isEmpty2["default"])(labels);
  var headerLabel = hasLabel ? labels === null || labels === void 0 ? void 0 : labels.find(function (label) {
    var _label$context;
    return ((_label$context = label.context) === null || _label$context === void 0 ? void 0 : _label$context.search) === 1;
  }) : undefined;
  var innerLabels = hasLabel ? labels === null || labels === void 0 ? void 0 : labels.filter(function (label) {
    var _label$context2;
    return ((_label$context2 = label.context) === null || _label$context2 === void 0 ? void 0 : _label$context2.search) === 2;
  }) : undefined;
  var openHotelInNewTab = function openHotelInNewTab() {
    Object.assign(document.createElement('a'), {
      target: openInCurrentTab ? '_self' : '_blank',
      rel: 'noopener noreferrer',
      href: hotelHref
    }).click();
  };
  return /*#__PURE__*/_react["default"].createElement(StyledHotelSmallCard, {
    className: className,
    isMobile: isMobile,
    itemScope: true,
    itemType: "https://schema.org/Hotel"
  }, headerLabel && !isMapCard ? /*#__PURE__*/_react["default"].createElement(_HotelCardHeaderLabel["default"], headerLabel) : null, /*#__PURE__*/_react["default"].createElement(StyledHotelOfferCardContent, {
    hasLabel: hasLabel
  }, /*#__PURE__*/_react["default"].createElement(StyledImageContainer, null, /*#__PURE__*/_react["default"].createElement(StyledHotelCardGallery, {
    images: images,
    isViewed: isViewed,
    isMobile: isMobile,
    bonusCount: bonus_count,
    cashbackIdentifier: cashbackIdentifier,
    customCashbackIconURL: customCashbackIconURL,
    customCashbackText: customCashbackText,
    customCashbackTooltipText: customCashbackTooltipText,
    link: hotelHref,
    isSmall: true,
    currencyCode: currencyCode,
    openInCurrentTab: openInCurrentTab,
    isPreloadable: isPreloadable
  }), /*#__PURE__*/_react["default"].createElement(StyledWrapper, null, /*#__PURE__*/_react["default"].createElement(StyledTopContent, null, /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_HotelStars["default"], {
    value: stars
  }), /*#__PURE__*/_react["default"].createElement(_HotelCardTitle["default"], {
    name: name,
    href: hotelHref,
    hasLtExtras: hasLtExtras,
    dataLayer: dataLayer,
    isSmallCard: true,
    isMapCard: isMapCard
  }), /*#__PURE__*/_react["default"].createElement("div", {
    itemProp: "address",
    itemScope: true,
    itemType: "https://schema.org/PostalAddress"
  }, /*#__PURE__*/_react["default"].createElement(StyledLocationLabel, {
    itemProp: "addressRegion"
  }, location))), /*#__PURE__*/_react["default"].createElement(StyledHotelCardRating, {
    rating: rating
  })))), /*#__PURE__*/_react["default"].createElement(StyledContentContainer, {
    onClick: openHotelInNewTab
  }, /*#__PURE__*/_react["default"].createElement(StyledHotelCardFacts, {
    line: line,
    beachSurface: beachSurface,
    beachDistance: beachDistance,
    airportDistance: airportDistance,
    wifiType: wifiType,
    emptyFeature: emptyFeature
  }), /*#__PURE__*/_react["default"].createElement(StyledFeaturesContainer, null, /*#__PURE__*/_react["default"].createElement(_HotelCardTags["default"], {
    extras: extras,
    cancellationPolicy: cancellationPolicy,
    isHotelOnly: isHotelOnly
  }), /*#__PURE__*/_react["default"].createElement(_LabelList.LabelList, {
    labels: innerLabels,
    maxLabels: maxLabels
  })), FooterComponent ? /*#__PURE__*/_react["default"].createElement(FooterComponent, {
    href: hotelHref
  }) : /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_WarningPlacesEnd["default"], {
    flight: availability.flight,
    hotel: availability.hotel,
    isHotelOnly: isHotelOnly
  }), /*#__PURE__*/_react["default"].createElement(_HotelCardPrice["default"], {
    price: price,
    priceWithCashback: priceWithCashback,
    currencyCode: currencyCode,
    cheapType: cheapType,
    oldPrice: previousPrice,
    href: hotelHref,
    instantConfirm: instantConfirm,
    dataLayer: dataLayer,
    isSmallCard: true,
    isMapCard: isMapCard
  }), !isMapCard && /*#__PURE__*/_react["default"].createElement(_HotelCardOfferInfo.HotelCardOfferInfo, {
    date: date,
    nightsCount: nights,
    surcharge: surcharge,
    currencyCode: currencyCode,
    isSmallCard: true,
    isHotelOnly: isHotelOnly,
    isFlexDates: isFlexDates
  }))), !isMapCard && suggestedDates && suggestedDates.length > 0 && /*#__PURE__*/_react["default"].createElement(StyledSuggestedWrapper, null, /*#__PURE__*/_react["default"].createElement(_HotelCardSuggestedDates["default"], {
    items: suggestedDates.slice(0, 2),
    isHotelOnly: isHotelOnly
  })), /*#__PURE__*/_react["default"].createElement("div", {
    onClick: openHotelInNewTab,
    onKeyDown: openHotelInNewTab
  }, /*#__PURE__*/_react["default"].createElement(_FiltersPenalized.FiltersPenalized, {
    penalized_filters: penalized_filters,
    onChangeFilter: onChangeFilter,
    isMobile: true
  }))));
};
var StyledHotelSmallCard = _styledComponents["default"].div.withConfig({
  displayName: "HotelCardSmall__StyledHotelSmallCard",
  componentId: "sc-175o0w2-0"
})(["width:100%;border-radius:", ";", ""], function (_ref2) {
  var theme = _ref2.theme;
  return theme.shape.borderRadius;
}, _styles.fixScroll);
var StyledHotelOfferCardContent = _styledComponents["default"].div.withConfig({
  displayName: "HotelCardSmall__StyledHotelOfferCardContent",
  componentId: "sc-175o0w2-1"
})(["min-height:262px;display:flex;flex-direction:column;position:relative;overflow:hidden;background:", ";border-radius:", ";", " ", " ", ""], function (_ref3) {
  var theme = _ref3.theme;
  return theme.colors.white;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.shape.borderRadius;
}, _styles.fixScroll, function (_ref5) {
  var hasLabel = _ref5.hasLabel;
  return hasLabel && "\n      border-top-left-radius: 0px;\n      border-top-right-radius: 0px;\n    ";
}, function (_ref6) {
  var isMobile = _ref6.isMobile;
  return isMobile && "\n      min-width: 320px;\n      width: 100%;\n    ";
});
var StyledImageContainer = _styledComponents["default"].div.withConfig({
  displayName: "HotelCardSmall__StyledImageContainer",
  componentId: "sc-175o0w2-2"
})(["flex-grow:0;flex-shrink:0;height:170px;position:relative;"]);
var StyledHotelCardGallery = (0, _styledComponents["default"])(_HotelCardGallery["default"]).withConfig({
  displayName: "HotelCardSmall__StyledHotelCardGallery",
  componentId: "sc-175o0w2-3"
})(["width:100%;height:100%;", "{top:35px;height:50px;width:30px;}"], _HotelCardGallery.StyledArrowIcon);
var StyledWrapper = _styledComponents["default"].div.withConfig({
  displayName: "HotelCardSmall__StyledWrapper",
  componentId: "sc-175o0w2-4"
})(["width:100%;position:absolute;pointer-events:none;z-index:10;bottom:0;"]);
var StyledTopContent = _styledComponents["default"].div.withConfig({
  displayName: "HotelCardSmall__StyledTopContent",
  componentId: "sc-175o0w2-5"
})(["display:flex;padding-right:8px;padding-left:8px;padding-bottom:5px;align-items:flex-end;justify-content:space-between;background:linear-gradient( to bottom,transparent,", " );"], function (_ref7) {
  var theme = _ref7.theme;
  return theme.colors.blackLight;
});
var StyledLocationLabel = _styledComponents["default"].div.withConfig({
  displayName: "HotelCardSmall__StyledLocationLabel",
  componentId: "sc-175o0w2-6"
})(["height:15px;line-height:15px;color:", ";font-size:12px;overflow:hidden;text-overflow:ellipsis;"], function (_ref8) {
  var theme = _ref8.theme;
  return theme.colors.frenchGray;
});
var StyledHotelCardRating = (0, _styledComponents["default"])(_HotelCardRating["default"]).withConfig({
  displayName: "HotelCardSmall__StyledHotelCardRating",
  componentId: "sc-175o0w2-7"
})(["margin-left:10px;margin-bottom:19px;"]);
var StyledContentContainer = _styledComponents["default"].div.withConfig({
  displayName: "HotelCardSmall__StyledContentContainer",
  componentId: "sc-175o0w2-8"
})(["display:flex;flex-direction:column;padding:8px;padding-top:8px;flex-grow:1;"]);
var StyledHotelCardFacts = (0, _styledComponents["default"])(_HotelCardFacts["default"]).withConfig({
  displayName: "HotelCardSmall__StyledHotelCardFacts",
  componentId: "sc-175o0w2-9"
})(["margin-bottom:", "px;"], function (_ref9) {
  var emptyFeature = _ref9.emptyFeature;
  return emptyFeature ? 0 : 8;
});
var StyledFeaturesContainer = _styledComponents["default"].div.withConfig({
  displayName: "HotelCardSmall__StyledFeaturesContainer",
  componentId: "sc-175o0w2-10"
})(["display:inline-flex;flex-direction:column-reverse;margin-bottom:8px;"]);
var StyledSuggestedWrapper = _styledComponents["default"].div.withConfig({
  displayName: "HotelCardSmall__StyledSuggestedWrapper",
  componentId: "sc-175o0w2-11"
})(["padding:0 4px 4px;"]);
var _default = exports["default"] = HotelCardSmall;